import React from "react";
import Header from "../header";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { apiCall_domain } from "../api";
import axios from "axios";
import Category from "./Category";
import Spinner from "../Spinner/Spinner";
import { createGlobalStyle } from "styled-components";
import MapCom from "./Map";
import { makeStyles } from "@mui/styles";
import CategoryDrawer from "./CategoryDrawer";
import UserAddressDrawer from "./userAddressDrawer";
const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
});
const classes = useStyles;
let DetailsAdd = null;
class multiVendor extends React.Component {
  state = {
    garages: [],
    loading: true,
    Days: [],
    filter: true,
    myAddresses: [],
    show: false,
    county: [],
    lng: null,
    lat: null,
    services: [],
    handelPushHomePage: true,
  };

  componentDidMount() {
    localStorage.setItem("status", "");
    const Headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/splash`, {
        headers: Headers,
      })
      .then((res) => {
        this.setState({ county: res.data.cities });
      });
    axios
      .get(`${apiCall_domain}/customer/mechanics/services`, {
        headers: Headers,
      })
      .then((res) => {
        this.setState({ services: res.data.data });
      });
    axios
      .get(`${apiCall_domain}/customer/user/addresses?1`, {
        headers: Headers,
      })
      .then((res) => {
        this.setState({
          myAddresses: Object.values(res.data.data),
          // loading: false,
        });
      });
    const Data = {
      type:
        this.props.location.Filter !== undefined
          ? this.props.location.Filter[0]
            ? this.props.location.Filter[0]
            : this.props.location.Filter[1]
          : "",
      kachar_suggests:
        this.props.location.Filter !== undefined &&
        this.props.location.Filter[2],
      rate:
        this.props.location.Filter !== undefined &&
        this.props.location.Filter[3],
      distance:
        this.props.location.Filter !== undefined &&
        parseInt(this.props.location.Filter[4] + "KM"),
      lat:
        localStorage.getItem("lat") !== undefined &&
        localStorage.getItem("lat"),
      lang:
        localStorage.getItem("lng") !== undefined &&
        localStorage.getItem("lng"),
      service: localStorage.getItem("categoryIdMultiVnedor")
        ? localStorage.getItem("categoryIdMultiVnedor")
        : "",
    };

    axios
      .post(`${apiCall_domain}/customer/mechanics/search`, Data, {
        headers: Headers,
      })
      .then((res) => {
        this.setState({ garages: res.data.data.garages }, () =>
          this.setState({ loading: false }),
        );
      });
  }
  render() {
    const GlobalStyles = createGlobalStyle`body{
            background: #F9F9F9;
          }`;
    return (
      <>
        {this.state.loading ? (
          <Spinner />
        ) : (
          <>
            <GlobalStyles />

            <Header
              showSearchBar={true}
              title={"انتخاب تعمیرگاه"}
              filter={this.state.filter}
              handelPushHomePage={this.state.handelPushHomePage}
            />
            <div className="multiVendorcom">
              <div className="PositionAndCategory">
                <UserAddressDrawer
                  myAddresses={this.state.myAddresses}
                  county={this.state.county}
                  props={this.props}
                />
                <CategoryDrawer services={this.state.services} />
              </div>
              <div className="tabsMultiVendor">
                <Tabs>
                  <TabList>
                    <Tab>نقشه</Tab>
                    <Tab>لیست</Tab>
                  </TabList>
                  <TabPanel index={0}>
                    <MapCom garages={this.state.garages} props={this.props} />
                  </TabPanel>
                  <TabPanel index={1}>
                    {this.state.garages.length === 0 ? (
                      <div className="noGarage">
                        تعمیر گاهی با این مشخصات یافت نشد.
                      </div>
                    ) : (
                      <Category
                        garages={this.state.garages}
                        props={this.props}
                        Days={this.state.Days}
                      />
                    )}
                  </TabPanel>
                </Tabs>
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}
export default multiVendor;
